import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Loader,
  Container,
  Segment,
  Item,
  Divider,
  Grid,
  Button,
} from "semantic-ui-react";
import TestataPagina from "../common/TestataPagina";
import moment from "moment";
import defaultImgCorso from "../../assets/images/defaults/defaultCourse.jpg";
import DettaglioCorsoStd from "./DettaglioCorsoStd";
import * as appActions from "../../redux/actions/appActions";
import * as corsiActions from "../../redux/actions/corsiActions";
import * as corsiApi from "../../api/corsiApi";
import useWindowSize from "../../utils/useWindowSize";
import DettaglioCorsoPacchetto from "./DettaglioCorsoPacchetto";
import { useTranslation } from "react-i18next";
import RedirectWithTrack from "../common/RedirectWithTrack";

function DettaglioCorso({
  appData,
  lang,
  datiScuola,
  promozioniNew,
  corsiData,
  cart,
  codScuola,
  idCorso,

  loadSessioni,
  setPrefsCorso,
  setCorsoDettagli,
  // setIdCorso,
  ...props
}) {
  /////////////////////////////////
  // STATE / constants
  const [isLoading, setIsLoading] = useState(true);
  const [redirectToAllievi, setRedirectToAllievi] = useState(false);
  const [redirectToCollettive, setRedirectToCollettive] = useState(false);
  const [picUrl, setPicUrl] = useState("");
  // const [noSessioni, setNoSessioni] = useState(false);
  const [noData, setNoData] = useState(false);
  // const [listaCorsi, setListaCorsi] = useState([]);
  // const [ready, setReady] = useState(false);
  const [idCorsoState, setIdCorsoState] = useState(0);
  function addDefaultSrc(ev) {
    ev.target.src = defaultImgCorso;
  }
  const windowSize = useWindowSize();
  const { t, i18n } = useTranslation([datiScuola.customTranslationNamespace]);

  /////////////////////////////////
  //EFFECT HOOKS

  useEffect(() => {
    i18n.emit("languageChanged");
  }, [datiScuola.customTranslationNamespace]);

  useEffect(() => {
    if (appData?.corsoDettagli?.idCorso !== idCorso) {
      console.log("Setting idCorso: ", idCorso);
      setIsLoading(true);
      setIdCorsoState(idCorso);
      datiScuola.idLinguaInUso = datiScuola.idLinguaInUso;
      //setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (datiScuola?.id === undefined || datiScuola?.id === null) return;
    if (idCorsoState > 0) {
      console.log("idCorsoState", idCorsoState);
      if (idCorsoState !== appData?.corsoDettagli?.idCorso) {
        reloadDatiCorso(idCorsoState);
      }
    }
  }, [idCorsoState, codScuola, datiScuola?.id]);

  useEffect(() => {
    if (appData.hasOwnProperty("lang")) {
      i18n.changeLanguage(appData.lang.toLowerCase());
    }
  }, [appData.lang]);

  ////////////////////////////////
  //HANDLERS
  function handleAvanti(
    primaData,
    giorni,
    numSessioni,
    allievi,
    prezzo,
    prezzoPag,
    prezzoListino,
    listaDate,
    scontoPromozione,
    scontoAgenzia,
    prezzoListinoRiferimento
  ) {
    if (
      cart.righeCollettive.find((x) => x.roomingList === true) !== undefined
    ) {
      alert(
        "Nel carrello è già presente un corso con rooming list, non è possibile aggiungere un altro corso"
      );
      return;
    }

    setPrefsCorso({
      primaData: primaData,
      numGiorni: giorni,
      numSessioni: numSessioni,
      numAllievi: allievi,
      prezzo: prezzo,
      prezzoPag: prezzoPag,
      prezzoListino: prezzoListino,
      prezzoListinoRiferimento: prezzoListinoRiferimento,
      listaDate: listaDate,
      scontoPromozione: scontoPromozione || 0,
      scontoAgenzia: scontoAgenzia || 0,
    });

    setRedirectToAllievi(true);
  }

  function getImgWidth() {
    const w = windowSize.width;
    if (w >= 990) return "618px";
    if (w > 600 && w < 990) return "480px";
    return "100%";
  }

  const reloadDatiCorso = async (idCorso) => {
    console.log("reloadDatiCorso", idCorso, datiScuola.id);
    if (idCorso === undefined) {
      console.log("idCorso is undefined, returning");
      return;
    }
    if (idCorso <= 0) {
      console.log("idCorso is <= 0, returning");
      return;
    }
    if (datiScuola?.id === undefined) {
      console.log("datiScuola.id is undefined, returning");
      return;
    }

    setIsLoading(true);

    console.log(
      "reloading dati corso... ",
      datiScuola?.id,
      idCorso,
      datiScuola?.idLinguaInUso
    );

    try {
      const res = await corsiApi.getCorso(
        datiScuola.id,
        idCorso,
        datiScuola.idLinguaInUso
      );
      console.log("API response:", res);

      if (res === undefined || res === null) {
        console.error("API returned null/undefined response");
        setNoData(true);
        return;
      }

      setCorsoDettagli(res);
      setPicUrl(
        `https://skiwork.blob.core.windows.net/webimg/${
          datiScuola.codicePrimario != null
            ? datiScuola.codicePrimario.toUpperCase()
            : codScuola.toUpperCase()
        }/${res?.picture}`
      );

      loadSessioni(
        datiScuola.id,
        res.id,
        moment().format("YYYY-MM-DD"),
        appData.agenzia !== undefined ? appData.agenzia.idAgenzia : -1,
        datiScuola.idLinguaInUso
      );
    } catch (error) {
      console.error("Error in reloadDatiCorso:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // console.log("useEffect corsiData", corsiData);
    // console.log("useEffect appData", appData);
    // console.log("useEffect codiceScuola", codScuola);

    if (corsiData?.sessioni === undefined) {
      return;
    }

    if (
      corsiData?.sessioni !== undefined &&
      appData?.corsoDettagli !== undefined &&
      appData?.slug !== undefined &&
      appData?.slug?.toLowerCase() === codScuola?.toLowerCase()
    ) {
      setIsLoading(false);
      //setNoSessioni(false);
    }
  }, [corsiData.sessioni]);

  if (noData) {
    return (
      <Container>
        {redirectToCollettive && (
          <RedirectWithTrack to={`/${lang}/${codScuola}/collettive/`} push />
        )}
        <div className="head-offset"></div>
        <TestataPagina
          titolo={t("corsi_collettivi")}
          icon="group"
          sottoTitolo={t("scegli_corso")}
        />
        <Segment
          className="padding_0_lr contenitore-grande"
          textAlign="center"
          style={{ marginBottom: "30px" }}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
              fontSize: "1.7rem",
            }}
          >
            Il corso richiesto non è al momento disponibile
          </p>
          <Button
            primary
            onClick={() => {
              setRedirectToCollettive(true);
            }}
          >
            RITORNA ALLA LISTA DEI CORSI
          </Button>
        </Segment>
      </Container>
    );
  }

  if (isLoading) {
    return (
      <>
        {redirectToCollettive && (
          <RedirectWithTrack to={`/${lang}/${codScuola}/collettive/`} push />
        )}
        <Loader active size="huge"></Loader>
      </>
    );
  } else {
    return (
      <Container>
        {redirectToCollettive && (
          <RedirectWithTrack to={`/${lang}/${codScuola}/collettive/`} push />
        )}
        <div className="head-offset"></div>
        {redirectToAllievi && (
          <RedirectWithTrack
            to={`/${appData.lang}/${appData.slug}/collettive/allievi`}
            push
          />
        )}
        <TestataPagina
          titolo={t("corsi_collettivi")}
          icon="group"
          sottoTitolo={t("scegli_corso")}
        />
        <Segment
          className="padding_0_lr contenitore-grande"
          style={{ marginBottom: "30px" }}
        >
          <Segment
            basic
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              paddingLeft: "17px",
            }}
            className="padding_0_top"
          >
            <Grid columns="equal" stackable>
              <Grid.Column
                width={windowSize.width > 600 ? 10 : 16}
                className="padding_0_lr"
              >
                <div
                  style={{
                    width: getImgWidth(),
                    height: "0",
                    paddingBottom: "66%",
                    position: "relative",
                  }}
                >
                  <img
                    onError={addDefaultSrc}
                    src={picUrl}
                    alt="category"
                    className="skiwork-image"
                    width="100%"
                    height="100%"
                  ></img>
                </div>
              </Grid.Column>
              <Grid.Column
                width={windowSize.width > 600 ? 6 : 16}
                className="padding_0_top padding_0_lr"
              >
                <Item.Group>
                  <Item>
                    <Item.Content>
                      <Item.Header
                        className="skiwork-titolo"
                        dangerouslySetInnerHTML={{
                          __html: appData.corsoDettagli?.titolo,
                        }}
                      >
                        {/* {appData.corsoDettagli.titolo} */}
                      </Item.Header>
                      <Item.Meta
                        className="skiwork-sottotitolo"
                        dangerouslySetInnerHTML={{
                          __html: appData.corsoDettagli?.sottoTitolo,
                        }}
                      >
                        {/* {appData.corsoDettagli.sottoTitolo} */}
                      </Item.Meta>
                      <Divider />
                      <Item.Description>
                        <p
                          className="skiwork-testi"
                          style={{ textAlign: "justify" }}
                          dangerouslySetInnerHTML={{
                            __html: appData.corsoDettagli?.descrizione,
                          }}
                        ></p>
                      </Item.Description>
                    </Item.Content>
                  </Item>
                </Item.Group>
              </Grid.Column>
            </Grid>
          </Segment>
          {appData.corsoDettagli?.tipoVenditaWeb === 1 && (
            <DettaglioCorsoPacchetto
              sessioniCorso={corsiData.sessioni}
              corso={appData.corsoDettagli}
              onAvantiClick={handleAvanti}
              datiScuola={datiScuola}
              promozioniNew={promozioniNew}
              appData={appData}
            />
          )}
          {appData.corsoDettagli?.tipoVenditaWeb !== 1 && (
            <DettaglioCorsoStd
              sessioniCorso={corsiData.sessioni}
              corso={appData.corsoDettagli}
              onAvantiClick={handleAvanti}
              datiScuola={datiScuola}
              promozioniNew={promozioniNew}
              lang={appData.lang}
              appData={appData}
              roomingList={
                appData.corsoDettagli?.roomingList &&
                appData.agenzia?.tipo === "agente"
              }
              // roomingList={
              //   appData.corsoDettagli.roomingList &&
              //   appData.agenzia.tipo === "agente"
              // }
            />
          )}
        </Segment>
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    idCorso: ownProps.match.params.idCorso,
    appData: state.appReducer,
    datiScuola: state.scuolaReducer,
    promozioniNew: state.promozioniNewReducer,
    cart: state.cartReducer,
    corsiData: state.corsi,
    loading: state.apiCallsInProgress > 0,
  };
}

const mapDispatchToProps = {
  setPrefsCorso: appActions.setPrefsCorso,
  setCorsoDettagli: appActions.setCorsoDettagli,
  loadSessioni: corsiActions.loadSessioni,
};

export default connect(mapStateToProps, mapDispatchToProps)(DettaglioCorso);
